import * as reducer from "./reducers";
import * as actionCreator from "./actionCreators";

export const reducers = reducer;
export const actionCreators = actionCreator;
